<div class="vtz-form__rank-container vtz-form__rank-container--selected vtz-text" role="listitem" id="ranked-statements-container"
  [attr.aria-label]="'Option ' + (index + 1) + ': ' + ranked().description">
  <div style="display: flex; align-items: center; gap: 10px;">
    @if (!isStringEmpty(ranked().choices[0].choiceDetails?.imageUrl)) {
      <img class="unranked-image" src="{{ranked().choices[0].choiceDetails?.imageUrl}}" [alt]="ranked().description">
    }  
    <div style="display: flex; flex-direction: column;">
      <div style="display: flex;align-items: center;">
        <p style="margin: 0;">{{ ranked().description }}</p>
  
        @if (!isStringEmpty(ranked().choices[0].choiceDetails?.webUrl)) {
          <a mat-icon-button 
             matTooltip="{{tooltipText}}"
             matTooltipPosition="above"
             href="{{ranked().choices[0].choiceDetails?.webUrl}}" 
             target="_blank">
            <mat-icon style="color: #365a8a !important;">info</mat-icon>
          </a>
        }
      </div>  
      <p style="margin: 0;">{{ ranked().description1 }}</p>
    </div>
  </div>

  <div style="display: flex; justify-content: flex-end; gap: 10px;align-items: center;" i18n>
    @if (isMobileScreen) {
    @if (ranked().isWriteIn) {
    <div class="focus-container-ranked">
      <button mat-mini-fab color="primary" (click)=onWriteInEdit() aria-label="Edit write-in name">
        <mat-icon style="color: white;height: 50p">edit</mat-icon>
      </button>
    </div>
    }
    <div class="focus-container">
      <button mat-mini-fab color="primary"
        [attr.aria-label]="'Rank'+ (index + 1) + '. ' + ranked().description + 'lower'" (click)="onMoveDown()">
        <mat-icon svgIcon="down-arrow" style="height: 50px;"></mat-icon>
      </button>
    </div>
    <div class="focus-container">
      <button mat-mini-fab color="primary"
        [attr.aria-label]="'Rank'+ (index + 1) + '. ' + ranked().description + 'higher'" (click)="onMoveUp()" id="rankUpMobile{{index}}">
        <mat-icon svgIcon="up-arrow" style="height: 50px;"></mat-icon>
      </button>
    </div>
    }
    @if (!isMobileScreen) {
    @if (ranked().isWriteIn) {
    <div class="focus-container-ranked">
      <button mat-mini-fab color="primary" (click)=onWriteInEdit() aria-label="Edit write-in name">
        <mat-icon style="color: white;">edit</mat-icon>
      </button>
    </div>
    }
    <div class="focus-container">
      <button mat-fab extended color="primary"
        [attr.aria-label]="'Rank'+ (index + 1) + '. ' + ranked().description + 'lower'" (click)="onMoveDown()"
        style="color: white;">
        <mat-icon class="extended-fab-button">arrow_downward</mat-icon>
        Lower
      </button>
    </div>

    <div class="focus-container">
      <button id="rankUpDesktop{{index}}" class="extended-fab-button" mat-fab extended color="primary"
        [attr.aria-label]="'Rank'+ (index + 1) + '. ' + ranked().description + 'upper'" (click)="onMoveUp()" 
        style="color: white;">
        <mat-icon style="color: white;">arrow_upward</mat-icon>
        Higher
      </button>

    </div>
    }

  </div>

</div>